import { createAction } from '@reduxjs/toolkit';
import type { GetIssueDto } from '../../services/issueService';
import type { IssueStatusFilter, PreviewIssueTime } from '../types/issues';

// Issues action creators
export const setIssues = createAction<GetIssueDto[]>('issues/setIssues');
export const addIssue = createAction<GetIssueDto>('issues/addIssue');
export const updateIssueInStore = createAction<{
  issueId: number;
  updates: Partial<GetIssueDto>;
}>('issues/updateIssue');
export const removeIssue = createAction<number>('issues/removeIssue');
export const setIssuesLoading = createAction<boolean>('issues/setLoading');
export const setIssuesError = createAction<string | null>('issues/setError');
export const setFilterType = createAction<
  'audio' | 'text' | 'video' | 'image' | null
>('issues/setFilterType');
export const setFilterStatus = createAction<IssueStatusFilter>(
  'issues/setFilterStatus'
);
export const setSortBy = createAction<
  'newest' | 'oldest' | 'video-position' | 'recently-updated'
>('issues/setSortBy');
export const setCurrentDraftId = createAction<number | null>(
  'issues/setCurrentDraftId'
);
export const setIsEditingIssue = createAction<boolean>(
  'issues/setIsEditingIssue'
);
export const setPreviewIssueTime = createAction<PreviewIssueTime | null>(
  'issues/setPreviewIssueTime'
);
export const setSearchOpen = createAction<boolean>('issues/setSearchOpen');
export const setSearchQuery = createAction<string>('issues/setSearchQuery');
export const clearIssues = createAction('issues/clear');
